import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-55-amitabh-kant-guest.webp";
import ThumbImg from "../../assets/images/conversations/055.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: ak-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ak-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .ak-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .ak-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .ak-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .ak-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .ak-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ak-hero__title.ak-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ak-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ak-hero__spotify.ak-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ak-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .ak-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ak-hero__right.ak-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .ak-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .ak-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .ak-yt-thumb:hover img { opacity: 0.85; }
  .ak-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .ak-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .ak-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .ak-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .ak-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ak-body.ak-visible { opacity: 1; transform: translateY(0); }
  .ak-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .ak-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .ak-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ak-guest.ak-visible { opacity: 1; transform: translateY(0); }
  .ak-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .ak-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .ak-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .ak-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ak-inner { padding-left: 32px; padding-right: 32px; }
    .ak-hero { padding-top: 32px; padding-bottom: 48px; }
    .ak-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ak-hero__title { font-size: 24px; }
    .ak-hero__left { gap: 16px; }
    .ak-guest__title { font-size: 24px; margin-bottom: 24px; }
    .ak-guest__photo-bg { width: 260px; height: 300px; }
    .ak-guest__name { font-size: 24px; margin-top: 18px; }
    .ak-body__para { font-size: 14px; margin-bottom: 12px; }
    .ak-body { padding-bottom: 48px; }
    .ak-guest { padding-bottom: 48px; }
    .ak-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ak-inner { padding-left: 16px; padding-right: 16px; }
    .ak-hero { padding-top: 51px; padding-bottom: 30px; }
    .ak-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .ak-hero__left { gap: 30px; }
    .ak-hero__title { font-size: 30px; }
    .ak-body__para { font-size: 16px; margin-bottom: 10px; }
    .ak-guest__title { font-size: 30px; margin-bottom: 20px; }
    .ak-guest__photo-bg { width: 100%; height: 386px; }
    .ak-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .ak-body { padding-bottom: 30px; }
    .ak-guest { padding-bottom: 30px; }
    .ak-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ak-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "QjPr6UBnEOU";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="ak-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 55 Amitabh Kant"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="ak-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 55 Amitabh Kant thumbnail" />
      <div className="ak-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ak-hero">
      <div className="ak-inner">
        <div className="ak-hero__grid">
          <div className="ak-hero__left">
            <h1 ref={titleRef} className="ak-hero__title">
              EP 55 | Inside India's Journey Towards Energy Transition with Amitabh Kant
            </h1>
            <div ref={spotifyRef} className="ak-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/11ST3TaMSBF2nmb3yULpA4?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 55 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="ak-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="ak-body">
      <div className="ak-inner">
        <p className="ak-body__para">
          In this episode, we welcome one of the key protagonists for both electric mobility and hydrogen energy in India: Amitabh Kant. A distinguished bureaucrat and policymaker, he is recognized for his substantial contributions to the development of the Indian economy. An alumnus of St. Stephen's College and JNU, he joined the Indian Administrative Service (IAS) in 1980.
        </p>
        <p className="ak-body__para">
          Mr. Kant is renowned for his role in spearheading initiatives that have significantly impacted the economy, including Startup India, Make in India, and the highly successful Incredible India campaign, which repositioned the country as a global tourism destination. He is also credited with coining the slogan "Kerala: God's Own Country" during his tenure in the state.
        </p>
        <p className="ak-body__para">
          When the Planning Commission was dissolved in 2015, Kant was appointed Chief Executive Officer of the newly created NITI Aayog, the apex public policy think tank responsible for catalyzing India's economic development.
        </p>
        <p className="ak-body__para">
          As India's Sherpa at the G20 in 2023, under his leadership, 87 outcomes were achieved, and 118 documents were adopted—an impressive increase from past years. His vision and leadership have firmly established him as a pivotal figure in shaping India's policy landscape in the 21st century.
        </p>
        <p className="ak-body__para">
          In this episode, we explore India's efforts toward energy transition and understand how the country can become a global leader in clean mobility and hydrogen generation.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="ak-guest">
      <div className="ak-inner">
        <h2 className="ak-guest__title">Our Guest</h2>
        <div>
          <div className="ak-guest__photo-bg">
            <img src={GuestImg} alt="Amitabh Kant" />
          </div>
          <p className="ak-guest__name">Amitabh Kant</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep55AmitabhKant() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ak-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}